import LayoutBasic from "@/views/layouts/LayoutBasic";
import nomenclatureSynchronize from "@/views/nomenclature/synchronize";
import nomenclatureSynchronizeRetro from "@/views/nomenclature/retroSynchronize";
import NomenclatureStatistics from "@/views/nomenclature/Statistics";
import nomenclatureRevisions from "@/views/nomenclature/revisions";
import EditDrug from "@/views/nomenclature/Edit";
import DrugsRating from "@/views/drugs/Rating";
import exportDrugsFromSites from "@/views/drugs/exportFromSite";
import expireDates from "@/views/drugs/expireDates";
import UploadDrugsPhotos from "@/views/drugs/UploadDrugsPhotos";
import egkCodes from '@/views/egk/codes.vue'
import egkCodesIgnored from '@/views/egk/codesIgnored.vue'
import egkCodesGrouped from '@/views/egk/codesGrouped.vue'
import egkCodesModerated from '@/views/egk/codesModerated.vue'
import New from '@/views/nomenclature/New'
import EmptyLayout from "@/views/layouts/EmptyLayout";
import DrugSiteEdit from '@/views/drugs/DrugSiteEdit'
import CreateTasks from '@/views/drugs/CreateTasks'
import NewSiteDrug from '@/views/drugs/CreateSiteDrug'
import NoActiveEgkCodes from "@/views/egk/NoActiveEgkCodes";
import DrugProjectFAQ from "@/views/drugs/DrugFaq";
import BarCodesEdit from "@/views/nomenclature/BarCodes";
import DrugsDetailsList from "@/views/drugs/DrugsDetailsList.vue";
import DrugsSoldStatistics from "@/views/drugs/SoldStatistics.vue";
import DrugsSidePrices from "@/views/drugs/SidePrices.vue";
import StoreStatus from "@/views/drugs/StoreStatus.vue";
import Manufacturers from "@/views/nomenclature/Manufacturers.vue";
import UploadNewDrugsPhotos from "@/views/drugs/UploadNewPhotos.vue"
import Relations from "@/views/nomenclature/Relations.vue";
import DrugComments from "@/views/nomenclature/DrugComments.vue";

const routes = [
  {
    path: '/nomenclature',
    component: LayoutBasic, // Change the desired Layout here,
    meta: {
      requiresAuth: true,
      permission: 'nomenclature'
    },
    children: [
      {
        path: 'barcodes',
        name: 'BarCodesEdit',
        component: BarCodesEdit
      },
      {
        path: 'manufacturers',
        name: 'NomenclatureManufacturers',
        component: Manufacturers
      },
      {
        path: 'synchronize',
        name: 'nomenclatureSynchronize',
        component: nomenclatureSynchronize
      },
      {
        path: 'synchronize2',
        name: 'nomenclatureSynchronize2',
        component: nomenclatureSynchronizeRetro
      },
      {
        path: 'statistics',
        name: 'NomenclatureStatistics',
        component: NomenclatureStatistics
      },
      {
        path: 'revisions',
        name: 'nomenclatureRevisions',
        component: nomenclatureRevisions
      },
      {
        path: 'relations',
        name: 'NomenclatureRelatedDrugs',
        component: Relations,
        meta: {
          // allowedTo: [ROLES.ID.SuperAdmin],
          permission: 'nomenclature/relatedDrugs'
        }
      },
      {
        path: 'edit/:id?',
        name: 'EditDrug',
        component: EditDrug,
        meta: {
          // allowedTo: [ROLES.ID.SuperAdmin],
          permission: 'nomenclature/editDrug'
        }
      },
      {
        path: 'new',
        name: 'NewDrug',
        component: New,
        meta: {
          // allowedTo: [ROLES.ID.SuperAdmin],
          permission: 'nomenclature/newDrug'
        }
      },
      {
        path: 'drug/comments',
        name: 'NomenclatureDrugComments',
        component: DrugComments,
        meta: {
          // allowedTo: [ROLES.ID.SuperAdmin],
          permission: 'nomenclature/drug/comments'
        }
      }
    ]
  },
  {
    path: '/egk',
    component: LayoutBasic, // Change the desired Layout here,
    meta: {requiresAuth: true},
    children: [
      {
        path: 'noactive',
        name: 'noActiveEgkCodes',
        component: NoActiveEgkCodes
      },
      {
        path: 'codes',
        name: 'egkCodes',
        component: egkCodes
      },
      {
        path: 'codesIgnored',
        name: 'egkCodesIgnored',
        component: egkCodesIgnored
      },
      {
        path: 'codesGrouped',
        name: 'egkCodesGrouped',
        component: egkCodesGrouped
      },
      {
        path: 'codesModerated',
        name: 'egkCodesModerated',
        component: egkCodesModerated
      },
    ]
  },
  {
    path: '/drugs',
    component: LayoutBasic, // Change the desired Layout here
    meta: {requiresAuth: true},
    children: [
      {
        path: 'sold/statistics',
        component: DrugsSoldStatistics,
        name: 'DrugsSoldStatistics'
      },
      {
        path: 'store/status',
        component: StoreStatus,
        name: 'DrugStoreStatus'
      },
      {
        path: 'sideprices',
        component: DrugsSidePrices,
        name: 'DrugsSidePrices'
      },
      {
        path: 'details/list',
        component: DrugsDetailsList,
        name: 'DrugsDetailsList'
      },
      {
        path: 'project/faq',
        component: DrugProjectFAQ,
        name: 'DrugProjectFAQ'
      },
      {
        path: 'site',
        component: EmptyLayout,
        children: [{
          path: 'edit/:id?/:projectId?',
          name: 'DrugSiteEdit',
          component: DrugSiteEdit,
        }]
      },
      {
        path: 'new',
        component: NewSiteDrug,
        name: 'NewSiteDrug'
      },
      {
        path: 'createtasks',
        component: CreateTasks,
        name: 'CreateTasks'
      },
      {
        path: 'rating',
        name: 'DrugsRating',
        component: DrugsRating
      },
      {
        path: 'exportFromSite',
        name: 'exportDrugsFromSites',
        component: exportDrugsFromSites
      },
      {
        path: 'expireDates',
        name: 'expireDates',
        component: expireDates
      },
      {
        path: 'uploadPhotos',
        name: 'uploadDrugsPhotos',
        component: UploadDrugsPhotos
      },
      {
        path: 'uploadNewPhotos',
        name: 'uploadNewDrugsPhotos',
        component: UploadNewDrugsPhotos
      },
      {
        path: 'comments',
        name: 'DrugComments',
        component: DrugComments,
        meta: {
          // allowedTo: [ROLES.ID.SuperAdmin],
          permission: 'drugs/comments'
        }
      }
    ]
  },
]

export default routes;

